const signOut = async () => {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    try {
      const response = await fetch(`${API_BASE_URL}/signout`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
          }
      });
  
      if (response.ok) {
        console.log("✅ Signed out successfully");
        window.location.href = '/'; // Redirect to login page
      } else {
        console.error("❌ Failed to sign out");
      }
    } catch (error) {
      console.error("⚠️ Error signing out:", error);
    }
  };
  
  export default signOut;